import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button } from '@mantine/core'
import { getAllCountryList } from '../../../services/location'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-id',
  'filter[featured][is]': null,
  'filter[country.id][is]': null,
  'filter[active][is]': null,
}

const defaultType = [
  {
    value: 'true',
    label: 'Yes'
  },
  {
    value: 'false',
    label: 'No'
  },
]

const FormFilterSupplier = ({ paramSupplier, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)
  const [countryList, setCountryList] = useState([])

  const handleGetCountryList = async (countryId) => {
    const params = {
      'filter[id][is]': countryId,
      'page[num]': '1',
      'page[limit]': '99999',
    }
    try {
      const response = await getAllCountryList(params)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetCountryList()
    if (paramSupplier !== null) {
      if (paramSupplier[`filter[country.id][is]`]) {
        handleGetCountryList(paramSupplier[`filter[user_id][is]`])
      }
      handleSetParams(paramSupplier)
    }
    // eslint-disable-next-line
  }, [paramSupplier])

  const handleSetParams = (val) => {
    const prevParams = {
      'filter[featured][is]': val['filter[featured][is]'],
      'filter[country.id][is]': val[`filter[country.id][is]`],
      'filter[active][is]': val['filter[active][is]'],
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 10,
      // 'filter[request_number][is]': params['filter[request_number][is]'] === '' ? null : params['filter[request_number][is]']
    }
    applyFilter(valueParams)
    onClose()
  }


  return (
    <Box>
      <Box mb='md'>
        <Select
          name='filter[featured][is]'
          value={parameter['filter[featured][is]']}
          label='Select Featured Supplier'
          data={defaultType}
          onChange={(val) => handleChangeFilter('filter[featured][is]', val)}
          size='xs'
          clearable
        />
      </Box>
      <Box mb='md'>
        <Select
          name='filter[active][is]'
          value={parameter['filter[active][is]']}
          label='Select Active Supplier'
          data={defaultType}
          onChange={(val) => handleChangeFilter('filter[active][is]', val)}
          size='xs'
          clearable
        />
      </Box>
      <Box mb='md'>
        <Select
          name='filter[country.id][is]'
          value={parameter['filter[country.id][is]']}
          label='Select Country'
          data={countryList}
          onChange={(val) => handleChangeFilter('filter[country.id][is]', val)}
          size='xs'
          searchable
          nothingFoundMessage={'No Country Found'}
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
            <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormFilterSupplier